module.exports = "/images/vendor/flag-icon-css/flags/4x3/gb.svg?d3ddd6025a06a78535b0d432d14905bf";